module.exports = __webpack_public_path__ + "img/glasses.16b7363e.png";